import firebase from "@firebase/app";
import $models from '@/models'
// import $store from '@/store'
import util from '@/util'

// import invitationModelDefinition from '@/models/invitation'

const $invitation = $models.invitation;
const $userIncommingInvitation = $models.userIncommingInvitation;
const $userOutgoingInvitation = $models.userOutgoingInvitation;

const TYPE_GOAL         = 'Goal'
const TYPE_CHALLENGE    = 'Challenge'
const TYPE_SEQUENCE     = 'Sequence'
const TYPE_VISIONBOARD  = 'Visionboard'
const TYPE_GOALPILOT    = 'Goalpilot'

const TYPE_LIST = [ TYPE_GOAL, TYPE_CHALLENGE, TYPE_SEQUENCE, TYPE_VISIONBOARD, TYPE_GOALPILOT ]

// -----------------------------------------------------------------------------
export function invitation_send_to_existing_user({
  type,
  payload,
  sendCopy,
  personalMessage,
  receiverUserId,
  receiverEmail,
  // permissionLevel, // TODO: is granted directly, since not a new user?
}) {

  if ( !TYPE_LIST.includes( type ) ) {
    throw new Error('Invalid type: ' + type)
  }

  let authDisplayName = firebase.auth().currentUser.displayName;
  // let profile_pic = $models.userSettings.getters.get_profile_pic;
  // TODO: Get user name from settings

  let current_user_id = $models.user.defaultUserId;

  let data = {
    personalMessage,
    sendCopy,
    ...payload,
    // payload = visionboardId, goalId, challengeId, sequenceId + cachedName
  }

  let new_id = $userIncommingInvitation._get_uid()

  let pInvitation = $userIncommingInvitation.with({ uid: receiverUserId }).add({
    isNewUser:      false,
    type:           type,
    senderUserId:   current_user_id,
    senderName:     authDisplayName,
    receiverEmail:  receiverEmail,
    receiverUserId: receiverUserId,
    ...data
  }, new_id)

  let pOutgoingInvitation = $userOutgoingInvitation.add({ // <<<< TODO
    receiverUserId: receiverUserId,
    appContent: payload
  }, new_id)

  // TODO: also send an email here
  // TODO: grant permission

  // Return invitationId
  return Promise.all([ pInvitation, pOutgoingInvitation ]).then(() => new_id)
}

// -----------------------------------------------------------------------------
/*
@test
this.$api.invitation_send_by_mail({
  type: 'Goalpilot',
  payload: {},
  personalMessage: 'Hi there',
  sendCopy: true,
  receiverEmail: 'tw@wavefab.com',
  permissionLevel: 1,
})
*/
export function invitation_send_by_mail({
  type,
  payload,
  personalMessage,
  sendCopy,
  receiverEmail,
  permissionLevel,
}) {

  if ( !TYPE_LIST.includes( type ) ) {
    throw new Error('Invalid type: ' + type)
  }

  let authDisplayName = firebase.auth().currentUser.displayName;
  // TODO: Get user name from settings

  let current_user_id = $models.user.defaultUserId;

  let data = {
    personalMessage,
    permissionLevel,
    sendCopy,
    ...payload,
    // payload = visionboardId, goalId, challengeId, sequenceId + cachedName + cachedPicture
  }

  // TODO: Maybe md5 is more secure? (one way hash)
  let email_base64 = btoa( receiverEmail ); // Convert email to Base64 since @ and . are invalid characters
  let invitation_code = $invitation._get_uid()

  let pInvitation = $invitation.with({ email: email_base64 }).add({
    isNewUser:      true,
    type:           type,
    senderUserId:   current_user_id,
    senderName:     authDisplayName,
    receiverEmail:  receiverEmail,
    ...data
  }, invitation_code)

  let pOutgoingInvitation = $userOutgoingInvitation.add({
    email: receiverEmail,
    appContent: payload,
    invitationCode: invitation_code,
  }, invitation_code)

  // Return invitationId
  return Promise.all([ pInvitation, pOutgoingInvitation ]).then(() => invitation_code)
}

// -----------------------------------------------------------------------------
export function invitation_revoke_new_user({ email, invitationCode }) {

  if ( !email ) {
    throw new Error('Invalid email', email)
  }

  if ( !invitationCode ) {
    throw new Error('Invalid invitationCode', invitationCode)
  }

  // TODO: Figure out email from invitationId
  let email_base64 = btoa( email );
  let pRemInvitation = $invitation.with({ email: email_base64 }).remove( invitationCode )
  let pRemOutgoingInvitation = $userOutgoingInvitation.remove(invitationCode)

  return Promise.all([ pRemInvitation, pRemOutgoingInvitation ])
}

// -----------------------------------------------------------------------------
export function invitation_revoke_existings_user({ receiverUserId, invitationId }) {

  if ( !util.isValidId( receiverUserId ) ) {
    throw new Error('Invalid receiverUserId', receiverUserId)
  }

  if ( !util.isValidId( invitationId ) ) {
    throw new Error('Invalid invitationId', invitationId)
  }

  let pRemInvitation = $userIncommingInvitation
    .with({ uid: receiverUserId })
    .remove(invitationId)

  let pRemOutgoingInvitation = $userOutgoingInvitation.remove(invitationId)

  return Promise.all([ pRemInvitation, pRemOutgoingInvitation ])
}

// -----------------------------------------------------------------------------
export function invitation_accept({ invitationId, senderUserId, type, status = 1 }) {

  // Only for existing users

  const NOTIFY_SENDER = true;

  let pUpdateInvitation = $userIncommingInvitation.update(invitationId, { status })
  let pNotifySender = Promise.resolve();
  let pCreateUserSettings = Promise.resolve();

  if ( status === 1 ) {

    switch ( type ) {
      case TYPE_GOAL:
      break
      case TYPE_CHALLENGE:
      break
      case TYPE_SEQUENCE:
      break
      case TYPE_VISIONBOARD:
      break
      case TYPE_GOALPILOT:
      break
    }
  }

  if ( NOTIFY_SENDER ) {
    // let senderUserId = ...
    pNotifySender = $userOutgoingInvitation
      .with({ uid: senderUserId })
      .update(invitationId, { status })
    // TODO: Update goal
  }

  return Promise.all([
    pUpdateInvitation,
    pNotifySender,
    pCreateUserSettings
  ]);
}

// -----------------------------------------------------------------------------
export function invitation_decline(...args) {
  return invitation_accept({ status: 2, ...args })
}

// -----------------------------------------------------------------------------
export function invitation_contact_request({ invitationId }) {
  throw new Error('NOT_IMPLEMENTED');
}

// -----------------------------------------------------------------------------
export function invitation_contact_accept({ invitationId }) {
  throw new Error('NOT_IMPLEMENTED');
}

// -----------------------------------------------------------------------------
export function invitation_contact_decline({ invitationId }) {
  throw new Error('NOT_IMPLEMENTED');
}
